import Vue from 'vue';

export default {

    SET_SEARCHTERM (state, searchTerm) {
        state.searchTerm = searchTerm;
    },

    BROWSER_RESIZED (state, ww){
        state.ww = ww;
    },
    SET_CURRENT_ENTITY (state, entity){
        this._vm.$set(state, 'currentEntity', entity);
    },
    SET_CURRENT_TAKER (state, taker){
        this._vm.$set(state, 'currentTaker', taker);
    },
    REMOVE_CURRENT_TAKER (state){
        this._vm.$set(state, 'currentTaker', null);
    },
    SET_TAKER_GROUP (state, group){
        this._vm.$set(state, 'takerGroup', group);
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js